import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { FaCopy } from 'react-icons/fa';

import Button from '../../Button';
import './SectionCupom.scss';

function SectionCupom() {

  const cupons = [
    {
      titulo: 'Guaraná 2L',
      acao: true,
      ttlacao: 'por apenas',
      valor: '9',
      decimais: '90',
      codigo: 'Frango10',
      qrcode: 'https://www.cjf.jus.br/cjf/corregedoria-da-justica-federal/turma-nacional-de-uniformizacao/QRCODE.png/@@images/5b045579-9526-478a-9165-25a590ebab68.png',
      url: ''
    },
    // {
    //   titulo: 'Frango com Catupiry',
    //   acao: true,
    //   ttlacao: 'Ganhe',
    //   valor: '9',
    //   decimais: '90',
    //   codigo: 'Frango10',
    //   qrcode: 'https://www.cjf.jus.br/cjf/corregedoria-da-justica-federal/turma-nacional-de-uniformizacao/QRCODE.png/@@images/5b045579-9526-478a-9165-25a590ebab68.png',
    //   url: ''
    // },
    {
      titulo: 'Pepsi 2L',
      acao: true,
      ttlacao: 'por apenas',
      valor: '8',
      decimais: '90',
      codigo: 'Primedasemana',
      qrcode: 'https://www.cjf.jus.br/cjf/corregedoria-da-justica-federal/turma-nacional-de-uniformizacao/QRCODE.png/@@images/5b045579-9526-478a-9165-25a590ebab68.png',
      url: ''
    },
    {
      titulo: 'Corona',
      acao: true,
      ttlacao: 'Long Neck',
      valor: '9',
      decimais: '90',
      codigo: 'prime99',
      qrcode: 'https://www.cjf.jus.br/cjf/corregedoria-da-justica-federal/turma-nacional-de-uniformizacao/QRCODE.png/@@images/5b045579-9526-478a-9165-25a590ebab68.png',
      url: ''
    },
    {
      titulo: 'Budweiser',
      acao: true,
      ttlacao: 'Long Neck',
      valor: '8',
      decimais: '90',
      codigo: 'supremoprime',
      qrcode: 'https://www.cjf.jus.br/cjf/corregedoria-da-justica-federal/turma-nacional-de-uniformizacao/QRCODE.png/@@images/5b045579-9526-478a-9165-25a590ebab68.png',
      url: ''
    },
];

  return (
    <section className='cupons' id='cupomSection'>
        <h1>Cupons Pizza Prime</h1>
        <p>Cupons de descontos para Pizzas</p>
        <div className="cupons-stage">
          {cupons.map((cupom, index) => (
            <div key={index} className='cupons-item'>
              <h1>{cupom.titulo}</h1>
              {cupom.acao ? (
                <div className='acao'>
                  {cupom.ttlacao}
                </div>
              ) : null}
              <div className='preco'>
                <div className='moeda'>R$</div>                  
                <div className='valor'>{cupom.valor}</div>
                <div className='decimais'>,{cupom.decimais}</div>
              </div>
              <div className='ttlCodigo'>
                Use o código:
              </div>
              <div className='codigo'>
                  <strong>{cupom.codigo}</strong>
              </div>
              
              <div className='copiarCodigo'>
                <FaCopy /> Copiar Código
              </div>
              
              <div className='qrcode'>
                <img src={cupom.qrcode} alt='QR Code'/>
              </div>
              
              <div className='pedir-agora'>
                <Button type="pizzaprime-red" size="large-rounded">
                  Usar Cupom
                </Button>  
              </div>
              
              <div className='termos-condicoes'>
                <Link to=''>
                  Termos & Condições
                </Link>
              </div>
            </div>          
          ))}
        </div>

    </section>
  );
}

export default SectionCupom;
